import { render, staticRenderFns } from "./PaymentStatusBadge.vue?vue&type=template&id=316630dc&scoped=true"
import script from "./PaymentStatusBadge.vue?vue&type=script&lang=ts"
export * from "./PaymentStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316630dc",
  null
  
)

export default component.exports